import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { getCarInstanceById } from 'store/carInstance';
import { dropClientId, getCustomer, storeItem } from 'store/startPage';
import { changeActiveDealer } from 'store/user';
import { getDealer } from 'store/user/selectors';

export const useCustomNavigation = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const dealer = useSelector(getDealer);

  const openDealParametersPage = (application, url) => {
    if (application.dealer.id !== dealer) {
      dispatch(changeActiveDealer(application.dealer.id));
    }

    localStorage.setItem('worksheet', JSON.stringify(application));
    localStorage.removeItem('carinstanceId');
    localStorage.removeItem('customerId');

    dispatch(getCarInstanceById(application.carInstance.id, application.id));
    dispatch(getCustomer({ customerId: application.customer.id }));
    dispatch(dropClientId());
    dispatch(storeItem(application));

    return history.push(url);
  };

  return { openDealParametersPage };
};
